<template>
<v-app>
<resizable-page>
  <template v-slot:table="tableProps">
  <v-card>
    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      mobile-breakpoint
      :headers="headers"
      :items="table"
      :search="search"
      :loading="loadTable"
      loading-text="Loading... Please wait"
      ref="vTable"
      :height="tableProps.tableHeight"
      fixed-header
    >
    <template v-slot:item="{ item }">
        <tr  @click="onSelect(item)">
            <td>{{item.driver_name}}</td>
            
        </tr>
    </template>
    
    </v-data-table>
  </v-card>
    </template>
  </resizable-page>
  </v-app>
</template>

<script>
import vuetify from '@/plugins/vuetify'
import { ResizablePage } from "@/components";

  export default {
    vuetify,
    components: {ResizablePage
  },
     props: {
    data_id: null,
    },
    data () {
      return {
        loadTable: true,
        search: '',
        headers: [
          { text: 'Driver Name', value: 'driver_name' },
        ],
        table: [],
      }
    },
    async created() {
      
    this.getList();
    },
     methods: {
       // ambil data yang dibutuhkan
    async getList() { 
      
      console.log(this.data_id)
      await this.$store.dispatch("fms_driver/listActiveByLocation",this.data_id)
      this.table = await this.$store.getters["fms_driver/driver"]
      this.loadTable= false
    },

    //fungsi yang ada di parent di panggil saat memilih row di table
    onSelect (item) {
    // this.$parent.$parent.modalCloseList(item,this.options_location_category[index].location_category_name)
      this.$parent.$parent.$parent.modalCloseListVehicleDriver(item)
      },



 
     },

     
  }
</script>
<style>
.v-application--wrap {
  min-height: unset;
}
.v-list-item__title {
    font-size: 0.8rem;
}
.v-menu__content{
    z-index: 10 !important;
}
table > tbody > tr > td.fixed:nth-child(1), 
  table > thead > tr > th.fixed:nth-child(1) {
    position: sticky !important; 
    position: -webkit-sticky !important; 
    left: 0; 
    z-index: 9998;
    background: white;
  }
  table > thead > tr > th.fixed:nth-child(1) {
    z-index: 9999;
  }
</style>